import React, { useState } from 'react';
import { CheckCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import { message } from 'antd';

const Cadastro: React.FC = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        id_autodesk: '',
        password: '',
        password_confirmation: '',
        cpf: '',
        company: '',
        phone: '',
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormData({
            ...formData,
            [e.target.id]: e.target.value
        });
    };

    const handleRegister = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        if (formData.password !== formData.password_confirmation) {
            setError('As senhas não conferem.');
            setLoading(false);
            return;
        }

        try {
            const response = await api.post('/auth/register', {
                name: formData.name,
                email: formData.email,
                cpf: formData.cpf,
                id_autodesk: formData.id_autodesk,
                phone: formData.phone,
                company: formData.company,
                password: formData.password,
                password_confirmation: formData.password_confirmation
            });
            console.log(response.data);
            const { token, user } = response.data;

            localStorage.setItem('token', token);
            localStorage.setItem('user', JSON.stringify(user));

            message.success('Cadastro realizado com sucesso!');

            navigate('/dashboard-cliente');

        } catch (err: any) {
            console.error('Registration error:', err);
            setError(err.response?.data?.message || 'Falha no cadastro. Tente novamente.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="relative flex min-h-screen w-full flex-col items-center bg-[#f7f9fc] dark:bg-[#101922] font-sans">

            <main className="w-full max-w-7xl flex-1 px-4 sm:px-6 lg:px-8 py-8 md:py-12">
                <div className="flex flex-col gap-10">
                    <div className="flex flex-wrap justify-between gap-3 text-center">
                        <div className="flex w-full flex-col gap-2">
                            <p className="text-[#333333] dark:text-white text-4xl font-black leading-tight tracking-[-0.033em]">Crie sua Conta e Escolha seu Plano</p>
                            <p className="text-[#666666] dark:text-[#9dabb9] text-lg font-normal leading-normal">Comece a otimizar seus orçamentos de construção hoje mesmo.</p>
                        </div>
                    </div>
                    <div className="rounded-xl border border-gray-200 dark:border-gray-700/50 bg-white dark:bg-background-dark p-6 sm:p-8 shadow-sm">
                        {error && (
                            <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
                                {error}
                            </div>
                        )}
                        <form onSubmit={handleRegister}>
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-10 gap-y-8">
                                <div className="space-y-6">
                                    <h3 className="text-[#333333] dark:text-white text-lg font-bold leading-tight tracking-[-0.015em] pb-2 border-b border-gray-200 dark:border-gray-700">Informações Pessoais</h3>
                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-5 pt-2">
                                        <div className="sm:col-span-2">
                                            <label className="block text-sm font-medium text-gray-600 dark:text-gray-400 mb-1.5" htmlFor="name">Nome Completo</label>
                                            <input
                                                className="w-full bg-white dark:bg-[#283039] text-[#333333] dark:text-white border border-[#e0e0e0] dark:border-[#3b4754] rounded-lg h-11 px-4 focus:ring-2 focus:ring-[#137fec] focus:border-[#137fec] transition-shadow"
                                                id="name"
                                                placeholder="Seu nome completo"
                                                type="text"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-600 dark:text-gray-400 mb-1.5" htmlFor="cpf">CPF</label>
                                            <input className="w-full bg-white dark:bg-[#283039] text-[#333333] dark:text-white border border-[#e0e0e0] dark:border-[#3b4754] rounded-lg h-11 px-4 focus:ring-2 focus:ring-[#137fec] focus:border-[#137fec] transition-shadow" id="cpf" onChange={handleChange} placeholder="000.000.000-00" type="text" required />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-600 dark:text-gray-400 mb-1.5" htmlFor="id_autodesk">ID Autodesk</label>
                                            <input className="w-full bg-white dark:bg-[#283039] text-[#333333] dark:text-white border border-[#e0e0e0] dark:border-[#3b4754] rounded-lg h-11 px-4 focus:ring-2 focus:ring-[#137fec] focus:border-[#137fec] transition-shadow" id="id_autodesk" onChange={handleChange} placeholder="ID Autodesk" type="text" required />
                                        </div>
                                        <div className="sm:col-span-2">
                                            <label className="block text-sm font-medium text-gray-600 dark:text-gray-400 mb-1.5" htmlFor="company">Nome da Empresa (Opcional)</label>
                                            <input className="w-full bg-white dark:bg-[#283039] text-[#333333] dark:text-white border border-[#e0e0e0] dark:border-[#3b4754] rounded-lg h-11 px-4 focus:ring-2 focus:ring-[#137fec] focus:border-[#137fec] transition-shadow" id="company" onChange={handleChange} placeholder="Sua empresa" type="text" />
                                        </div>
                                    </div>
                                </div>
                                <div className="space-y-6">
                                    <h3 className="text-[#333333] dark:text-white text-lg font-bold leading-tight tracking-[-0.015em] pb-2 border-b border-gray-200 dark:border-gray-700">Informações de Contato e Acesso</h3>
                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-5 pt-2">
                                        <div className="sm:col-span-2">
                                            <label className="block text-sm font-medium text-gray-600 dark:text-gray-400 mb-1.5" htmlFor="email">E-mail</label>
                                            <input
                                                className="w-full bg-white dark:bg-[#283039] text-[#333333] dark:text-white border border-[#e0e0e0] dark:border-[#3b4754] rounded-lg h-11 px-4 focus:ring-2 focus:ring-[#137fec] focus:border-[#137fec] transition-shadow"
                                                id="email"
                                                placeholder="seu.email@exemplo.com"
                                                type="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        <div className="sm:col-span-2">
                                            <label className="block text-sm font-medium text-gray-600 dark:text-gray-400 mb-1.5" htmlFor="phone">Telefone</label>
                                            <input className="w-full bg-white dark:bg-[#283039] text-[#333333] dark:text-white border border-[#e0e0e0] dark:border-[#3b4754] rounded-lg h-11 px-4 focus:ring-2 focus:ring-[#137fec] focus:border-[#137fec] transition-shadow" id="phone" onChange={handleChange} placeholder="(00) 90000-0000" type="tel" />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-600 dark:text-gray-400 mb-1.5" htmlFor="password">Senha</label>
                                            <input
                                                className="w-full bg-white dark:bg-[#283039] text-[#333333] dark:text-white border border-[#e0e0e0] dark:border-[#3b4754] rounded-lg h-11 px-4 focus:ring-2 focus:ring-[#137fec] focus:border-[#137fec] transition-shadow"
                                                id="password"
                                                placeholder="Crie uma senha forte"
                                                type="password"
                                                value={formData.password}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-600 dark:text-gray-400 mb-1.5" htmlFor="password_confirmation">Confirme a Senha</label>
                                            <input
                                                className="w-full bg-white dark:bg-[#283039] text-[#333333] dark:text-white border border-[#e0e0e0] dark:border-[#3b4754] rounded-lg h-11 px-4 focus:ring-2 focus:ring-[#137fec] focus:border-[#137fec] transition-shadow"
                                                id="password_confirmation"
                                                placeholder="Repita a senha"
                                                type="password"
                                                value={formData.password_confirmation}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*<br />
                            <hr />
                            <br />
                            <div className="space-y-8">
                                <div className="flex flex-col items-center text-center gap-2">
                                    <h2 className="text-[#333333] dark:text-white text-3xl font-bold tracking-tight">Escolha o plano ideal para você</h2>
                                    <p className="text-[#666666] dark:text-[#9dabb9] text-lg max-w-2xl">Oferecemos opções flexíveis para atender às necessidades do seu negócio, desde projetos pontuais até uso contínuo.</p>
                                </div>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-start">
                                    <div className="flex flex-col rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-background-dark p-6 shadow-sm h-full">
                                        <div className="flex-grow">
                                            <h3 className="text-xl font-bold text-[#333333] dark:text-white">Plano Básico</h3>
                                            <p className="mt-1 text-gray-500 dark:text-gray-400">Ideal para freelancers e pequenas empresas.</p>
                                            <div className="mt-4">
                                                <span className="text-4xl font-extrabold text-[#333333] dark:text-white">R$99</span>
                                                <span className="ml-1 text-lg font-medium text-gray-500 dark:text-gray-400">/mês</span>
                                            </div>
                                            <ul className="mt-6 space-y-3 text-gray-600 dark:text-gray-300">
                                                <li className="flex items-center gap-2">
                                                    <CheckCircle className="text-green-500 size-5" />
                                                    <span>Até 10 orçamentos por mês</span>
                                                </li>
                                                <li className="flex items-center gap-2">
                                                    <CheckCircle className="text-green-500 size-5" />
                                                    <span>Importação de arquivos BIM</span>
                                                </li>
                                                <li className="flex items-center gap-2">
                                                    <CheckCircle className="text-green-500 size-5" />
                                                    <span>Suporte via e-mail</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <button className="mt-8 w-full flex items-center justify-center rounded-lg h-12 px-6 bg-[#137fec] text-white text-base font-bold hover:bg-opacity-90 transition-colors shadow-lg shadow-[#137fec]/30">
                                            Escolher Plano Básico
                                        </button>
                                    </div>

                                    <div className="flex flex-col rounded-xl border-2 border-[#137fec] dark:border-[#137fec] p-6 bg-white dark:bg-background-dark shadow-lg relative h-full">
                                        <div className="absolute -top-3.5 left-1/2 -translate-x-1/2">
                                            <span className="inline-block rounded-full bg-[#137fec] px-3 py-1 text-xs font-semibold uppercase tracking-wider text-white">Mais Popular</span>
                                        </div>
                                        <div className="flex-grow">
                                            <h3 className="text-xl font-bold text-[#333333] dark:text-white">Plano Premium</h3>
                                            <p className="mt-1 text-gray-500 dark:text-gray-400">Para construtoras e projetos complexos.</p>
                                            <div className="mt-4">
                                                <span className="text-4xl font-extrabold text-[#333333] dark:text-white">R$299</span>
                                                <span className="ml-1 text-lg font-medium text-gray-500 dark:text-gray-400">/mês</span>
                                            </div>
                                            <ul className="mt-6 space-y-3 text-gray-600 dark:text-gray-300">
                                                <li className="flex items-center gap-2">
                                                    <CheckCircle className="text-green-500 size-5" />
                                                    <span>Orçamentos ilimitados</span>
                                                </li>
                                                <li className="flex items-center gap-2">
                                                    <CheckCircle className="text-green-500 size-5" />
                                                    <span>Importação de arquivos BIM</span>
                                                </li>
                                                <li className="flex items-center gap-2">
                                                    <CheckCircle className="text-green-500 size-5" />
                                                    <span>Relatórios avançados</span>
                                                </li>
                                                <li className="flex items-center gap-2">
                                                    <CheckCircle className="text-green-500 size-5" />
                                                    <span>Suporte prioritário (telefone e e-mail)</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <button className="mt-8 w-full flex items-center justify-center rounded-lg h-12 px-6 bg-[#137fec] text-white text-base font-bold hover:bg-opacity-90 transition-colors shadow-lg shadow-[#137fec]/30">
                                            Escolher Plano Premium
                                        </button>
                                    </div>
                                </div>
                            </div>*/}
                            <div className="mt-8 flex justify-end">
                                <button
                                    type="submit"
                                    className="w-full sm:w-auto flex items-center justify-center rounded-lg h-12 px-8 bg-[#137fec] text-white text-base font-bold hover:bg-opacity-90 transition-colors shadow-lg shadow-[#137fec]/30 disabled:opacity-50 disabled:cursor-not-allowed"
                                    disabled={loading}
                                >
                                    {loading ? 'Criando conta...' : 'Criar Conta'}
                                </button>
                            </div>
                        </form>
                    </div>
                    {/*<div className="rounded-xl border border-gray-200 dark:border-gray-700/50 bg-white dark:bg-background-dark p-6 sm:p-8 shadow-sm flex flex-col sm:flex-row items-center justify-between gap-6">
                        <div className="text-center sm:text-left">
                            <h3 className="text-xl font-bold text-[#333333] dark:text-white">Não precisa de um plano?</h3>
                            <p className="mt-1 text-gray-600 dark:text-gray-400">Compre créditos para orçamentos avulsos e pague apenas pelo que usar.</p>
                        </div>
                        <button className="flex-shrink-0 w-full sm:w-auto items-center justify-center rounded-lg h-11 px-5 bg-gray-100 dark:bg-gray-700 text-[#333333] dark:text-white text-base font-medium hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors">
                            Comprar Créditos
                        </button>
                    </div>*/}
                    <div className="flex flex-col items-center gap-4 pt-4">
                        <p className="text-sm text-center text-[#666666] dark:text-gray-400">
                            Ao criar uma conta, você concorda com nossos <a className="font-medium text-[#137fec] hover:underline" href="/termos">Termos de Serviço</a> e <a className="font-medium text-[#137fec] hover:underline" href="/privacidade">Política de Privacidade</a>.
                        </p>
                    </div>
                </div >
            </main >
        </div >
    );
};

export default Cadastro;
